import { render, staticRenderFns } from "./ReportMedicalProblem.vue?vue&type=template&id=4332e5d1&scoped=true&"
import script from "./ReportMedicalProblem.vue?vue&type=script&lang=js&"
export * from "./ReportMedicalProblem.vue?vue&type=script&lang=js&"
import style0 from "./ReportMedicalProblem.vue?vue&type=style&index=0&id=4332e5d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4332e5d1",
  null
  
)

export default component.exports